import { httpsCallable, type Functions } from 'firebase/functions'
import type { CloudFunctionsService } from './types'

export interface FirebaseCloudFunctionsServiceDeps {
    functions: Functions
}

export class FirebaseCloudFunctionsService implements CloudFunctionsService {
    processHTMLToPDF: CloudFunctionsService['processHTMLToPDF']
    exchangeQontoToken: CloudFunctionsService['exchangeQontoToken']

    constructor(private readonly deps: FirebaseCloudFunctionsServiceDeps) {
        this.processHTMLToPDF = httpsCallableToFunction(
            this.deps.functions,
            'htmlToPdf',
        )
        this.exchangeQontoToken = httpsCallableToFunction(
            this.deps.functions,
            'exchangeQontoTokenFn',
        )
    }
}

function httpsCallableToFunction<Input, Output>(
    functions: Functions,
    name: string,
): (params: Input) => Promise<Output> {
    const callable = httpsCallable<Input, Output>(functions, name)
    return (params: Input) => callable(params).then((result) => result.data)
}
